import { useRealtimeConversationLogs } from './useRealtimeConversationLogs';

export const useWebSocketConversation = (conversationId: string, onError?: <T>(error: T) => void) =>
  useRealtimeConversationLogs('conversationLogsPaginated', conversationId, onError);
